import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import {
  AppBar,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  Icon,
  IconButton,
  Paper,
  Step,
  StepLabel,
  Stepper,
  TextField,
  Toolbar,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { AgGridReact } from "ag-grid-react";
import clsx from "clsx";
import React, { useEffect, useRef } from "react";
import { useState } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import Select from "react-select";
import customStyles from "app/shared-components/SelectCustomStyle";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import OAuthService from "src/app/auth/services/oAuthService";
import AgGridTable from "../utilities/AgGridTable";
import moment from "moment";
import Draggable from "react-draggable";
import { useTheme } from "@mui/material/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .order-detail-summary": {
      flexDirection: "row",
      display: "flex",
      flexWrap: "wrap",

      "& li": {
        padding: "5px 0",
        width: "50%",
        display: "flex",
        alignItems: "center",

        "& label": {
          display: "inline-block",
          width: "167px",
        },
      },
    },
  },
}));

const loadingWeekUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.deliveryInfoes}`;
const getDateUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.getDateFromyear}`;
function PaperComponent(props) {
  const nodeRef = React.useRef(null);
  return (
    <Draggable
      nodeRef={nodeRef}
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} ref={nodeRef} />
    </Draggable>
  );
}
export default function ContainerForm(props) {
  const classes = useStyles(props);
  const {
    open,
    onClose,
    newOrder,
    // selectedContainer,
    // data,
    containerTypeOptions,
    regionOptions,
    handleNewContainer,
    handleMoveOrders,
    loadingWeekOptions,
    containerTypeList,
    setOpenContainerForm,
    setLoadingWeekOptions,
    filteredLoadingWeek,
    hasPartner,
    selectedCompanyId,
    lacqueredRanges,
    isValidLoadingWeeks,
    uniqueLoadingWeek,
    activeStep,
    setActiveStep,
    formData,
    setFormData,
    uniqueLoadingYear,
    hasSuperRole,
  } = props;

  const [containerRowData, setContainerRowData] = useState([]);
  const [addMultipleContainer, setAddMultipleContainer] = useState([]);
  const [totalSteps, setTotalSteps] = useState(0);
  const [minMax, setMinMax] = useState({
    min: 0,
    max: 0,
  });
  const [destination, setDestination] = useState({});
  const [containerType, setContainerType] = useState({});
  const [containerStatus, setContainerStatus] = useState({
    value: "OPEN",
    label: "Open",
  });
  const [loadingWeek, setLoadingWeek] = useState();
  const [comment, setComment] = useState();
  const theme = useTheme();
  const [forwarderName, setForwarderName] = useState("");
  const [forwarderEmail, setForwarderEmail] = useState("");
  const [forwarderNumber, setForwarderNumber] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const [containerPlan, setContainerPlan] = useState({});
  const [gridApi, setGridApi] = useState(null);
  const gridRef = useRef();
  const [error, setError] = useState(false);
  const [weekOption, setWeekOption] = useState([]);
  const [currentWeek, setCurrentWeek] = useState("");
  const [currentYears, setCurrentYears] = useState("");
  const [cutOffDate, setCutOffDate] = useState("");
  const [maxValueContainer, setMaxValueContainer] = useState(0);
  const [stepsData, setStepsData] = useState([]);
  const [initialStepsCalculated, setInitialStepsCalculated] = useState(false);
  // const [portOptions,setPortOptions]=useState();
  const specialDiscountIcon = (params) => {
    const data = params?.data;
    if (!data) return null;

    const { commissionName, specialDiscountRequested, sdrStatus } = data;

    return (
      <span
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        {commissionName}
        {sdrStatus === "APPROVED" ? (
          <FuseSvgIcon
            size={18}
            sx={{ color: theme.palette.success.main }}
          >
            heroicons-solid:tag
          </FuseSvgIcon>
        ) : sdrStatus === "WAITING" || sdrStatus === "PENDING" ? (
          <FuseSvgIcon
            size={18}
            sx={{ color: theme.palette.error.main }}
          >
            heroicons-solid:tag
          </FuseSvgIcon>
        ) : (
          ""
        )}
      </span>
    );
  };
  const handleDateFormat = (props) => {
    return props.value && moment(props.value).format("DD-MM-YYYY");
  };
   const showDiscountPercentMoney = (props) => {
    const formattedValue = new Intl.NumberFormat("en-GB", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(props.value || 0);

    return (
      <p style={{ textAlign: "right", margin: 0 }}>{`${formattedValue}`}</p>
    );
  };
  useEffect(() => {
    if (open) {
      const week = loadingWeekOptions[0]?.value;
      const loadingDate = new Date(loadingWeekOptions[0]?.id).getFullYear();
      setLoadingWeek(`${week}/${loadingDate}`);

      if (loadingWeek) {
        let filteredLoadingWeek = [];
        if (week) {
          filteredLoadingWeek = loadingWeekOptions.filter(
            (item) => item.value !== week,
          );
        }
        setLoadingWeekOptions(filteredLoadingWeek);
      }
    }
  }, [open, loadingWeek]);

  const showFixedValue = (props) => {
    let formattedNumbers;
    if (Number.isNaN(props?.value) || props?.value === 0 || !props?.value) {
      formattedNumbers = "";
    } else {
      if (props.colDef.field === "volume" || props.colDef.field === "weight") {
        formattedNumbers = new Intl.NumberFormat("en-US", {
          maximumFractionDigits: 3,
          minimumFractionDigits: 3,
        }).format(props?.value);
      } else {
        formattedNumbers = new Intl.NumberFormat("en-US", {
          maximumFractionDigits: 2,
          minimumFractionDigits: 2,
        }).format(props?.value);
      }
    }
    return <p>{`${formattedNumbers}`}</p>;
  };

  const [containerColumnDefs, setContainerColumnDefs] = useState([
    {
      headerName: "Sr No.",
      minWidth: 60,
      maxWidth: 60,
      valueGetter: "node.rowIndex + 1",
    },
    {
      field: "abNumber",
      headerName: "AB Number",
      // width: 90,
    },
    {
      field: "commissionName",
      headerName: "Commission Name",
      cellRenderer: specialDiscountIcon,
      minWidth: 250,
    },
    {
      field: "vendorShortKey",
      headerName: "Product",
      maxWidth: 70,
      // width: 100
    },
    {
      field: "orderCategory",
      headerName: "Category",
    },
    {
      headerName: "Lacquered",
      valueGetter: (params) => {
        const { range1Id, range2Id, range3Id } = params.data || {};
        const lacqueredRanges = params.context?.lacqueredRanges || [];

        const isLacquered = [range1Id, range2Id, range3Id].some(
          (id) => id && lacqueredRanges.includes(id),
        );

        return isLacquered ? "Lacquered" : "";
      },
      // filter: "agTextColumnFilter",
      // filterParams: {
      //   filterOptions: ["contains"],
      //   defaultOption: "contains",
      // },
    },
    {
      field: "plannedLoadingWeek",
      headerName: "Loading Week",
      filterParams: {
        filters: [
          {
            filter: "agNumberColumnFilter",
            filterParams: { buttons: ["clear"] },
          },
          {
            filter: "agSetColumnFilter",
            filterParams: {
              defaultToNothingSelected: true,
              buttons: ["clear"],
            },
          },
        ],
      },
      // enableRowGroup: true,
      // minWidth: 70,
    },
    {
      headerName: "Region / Zone",
      field: "region",
    },
    {
      field: "volume",
      cellRenderer: showFixedValue,
      filterParams: {
        filters: [
          {
            filter: "agNumberColumnFilter",
            filterParams: { buttons: ["clear"] },
          },
          {
            filter: "agSetColumnFilter",
            filterParams: {
              defaultToNothingSelected: true,
              buttons: ["clear"],
            },
          },
        ],
      },
      // width: 100
    },
    {
      field: "orderStatus",
      // width: 150
    },
    {
      field: "orderConfirmedDate",
      cellRenderer: handleDateFormat,
    },
    {
        field: "cutoffDate",
        cellRenderer: handleDateFormat,
        minWidth: 60,
        hide: !hasSuperRole,
      },
      {
        headerName: "Receivable",
        field: "grandTotal",
        minWidth: 60,
        cellRenderer: showDiscountPercentMoney,
        hide: !hasSuperRole,
      },
  ]);

  const containerStatusOptions = [
    { value: "OPEN", label: "Open" },
    { value: "CLOSE", label: "Close" },
    {
      value: "BOOKING_REQUEST_SENT_TO_FACTORY",
      label: "Booking request sent to factory",
    },
    {
      value: "BOOKING_REQUEST_SENT_TO_NFZE",
      label: "Booking request sent to NFZE",
    },
    {
      value: "BOOKING_REQUEST_SENT_TO_GERMANY",
      label: "Booking request sent to germany",
    },
    { value: "CLEAN_TO_ISSUE_PI", label: "Clean to Issue PI" },
    { value: "BOOKED", label: "Booked" },
    { value: "READY_TO_RELEASE", label: "Ready to Release" },
    { value: "RELEASED", label: "Released" },
    { value: "LOADED", label: "Loaded" },
  ];

  const onSelectionChanged = (params) => {
    setSelectedRows(params.api.getSelectedRows());
  };
  const onRowDoubleClicked = (params) => {
    const id = params.data?.id;
    if (id) {
      if (hasPartner && token?.company === params?.data?.customerNum) {
        window.open(`/order/order-details/${id}`, "_blank");
      } else {
        window.open(`/order/order-details/${id}`, "_blank");
      }
    }
  };
  const onGridReady = (params) => {
    setGridApi(params);
  };
  useEffect(() => {
    if (open && !initialStepsCalculated) {
      const sortedItemList = [...newOrder].sort((a, b) => b.volume - a.volume);
      let remainingItems = [...sortedItemList];

      const defaultContainer = containerTypeList[0];
      const hasEK = newOrder.some((order) => order.vendorShortKey === "EK");
      const hasNonEK = newOrder.some((order) => order.vendorShortKey !== "EK");
      const isMixed = hasEK && hasNonEK;

      const volumeKey = isMixed ? "mixedMaxVolume" : "maxVolume";
      const MAX_VOLUME =
        defaultContainer?.[volumeKey] || defaultContainer?.maxVolume;

      const getItemsForStep = (items, limit) => {
        let currentVolume = 0;
        const stepItems = [];

        for (const item of items) {
          if (currentVolume + item.volume <= limit) {
            stepItems.push(item);
            currentVolume += item.volume;
          }
        }

        return stepItems;
      };

      const steps = [];

      while (remainingItems.length > 0) {
        const chunk = getItemsForStep(remainingItems, MAX_VOLUME);
        if (chunk.length === 0) break; // safety to avoid infinite loop
        remainingItems = remainingItems.filter((i) => !chunk.includes(i));
        steps.push(chunk);
      }

      setStepsData(steps);
      setInitialStepsCalculated(true);
    }
  }, [open, containerTypeList, newOrder, initialStepsCalculated]);

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSelectChange = (selectedOption, field) => {
    // Handle container type selection with volume validation
    if (field.includes("containerType")) {
      const selectedContainerType = containerTypeList.find(
        (ct) => ct.containerId === selectedOption.value,
      );

      const currentStepOrders = stepsData[activeStep] || [];

      const hasEK = currentStepOrders.some(
        (order) => order.vendorShortKey === "EK",
      );
      const hasNonEK = currentStepOrders.some(
        (order) => order.vendorShortKey !== "EK",
      );
      const isMixed = hasEK && hasNonEK;

      const selectedMaxVolume = isMixed
        ? selectedContainerType?.mixedMaxVolume
        : selectedContainerType?.maxVolume;

      const currentTotalVolume = currentStepOrders.reduce(
        (sum, order) => sum + Number(order.volume),
        0,
      );

      if (currentTotalVolume > selectedMaxVolume) {
        alert(
          `Total volume of orders in this step (${currentTotalVolume.toFixed(
            3,
          )}) exceeds the selected container's ${isMixed ? "mixed max" : "max"
          } volume (${selectedMaxVolume}). Please reduce volume or choose a different type.`,
        );
        return;
      }

      // Update container type field with volume info
      setFormData((prevData) => ({
        ...prevData,
        [field]: {
          ...selectedOption,
          volume: selectedMaxVolume,
        },
      }));
      return; // prevent fallthrough to next block
    }

    // For other fields like loadingWeek and destination
    setFormData((prevData) => ({
      ...prevData,
      [field]: selectedOption,
    }));

    if (field.includes("loadingWeek")) {
      setCurrentWeek(selectedOption.value);
      setCurrentYears(selectedOption.year);
    }
  };

  const handleNext = () => {
    setActiveStep((prevActiveStep) => {
      const nextStep = prevActiveStep + 1;

      const prevDestination =
        formData[`destination${prevActiveStep + 1}`] || "";
      const prevLoadingWeek =
        formData[`loadingWeek${prevActiveStep + 1}`] || "";

      // setFormData((prevData) => ({
      //   ...prevData,
      //   [`destination${nextStep}`]: prevDestination,
      //   [`loadingWeek${nextStep}`]: prevLoadingWeek,
      // }));
      setFormData((prevData) => ({
        ...prevData,
        [`destination${nextStep}`]: { ...prevDestination },
        [`loadingWeek${nextStep}`]: { ...prevLoadingWeek },
      }));

      if (prevActiveStep === stepsData.length - 1) {
        handleNewContainer(formData, prevActiveStep, stepsData, cutOffDate);
        setOpenContainerForm(false);
        setStepsData([]);
        setInitialStepsCalculated(false);
      }

      return nextStep;
    });
  };
  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };
  useEffect(() => {
    if (activeStep >= 0) {
      const currentStep = activeStep + 1;
      const previousStep = activeStep;

      setFormData((prevData) => {
        const updatedData = { ...prevData };

        if (!updatedData[`containerStatus${currentStep}`]) {
          updatedData[`containerStatus${currentStep}`] = {
            value: "OPEN",
            label: "Open",
          };
        }

        if (
          !updatedData[`containerType${currentStep}`] &&
          containerTypeList.length > 0
        ) {
          const currentOrders = stepsData[activeStep] || [];
          const currentVolume = currentOrders.reduce(
            (sum, order) => sum + Number(order.volume),
            0,
          );

          const hasEK = currentOrders.some(
            (order) => order.vendorShortKey === "EK",
          );
          const hasNonEK = currentOrders.some(
            (order) => order.vendorShortKey !== "EK",
          );
          const isMixed = hasEK && hasNonEK;

          const volumeKey = isMixed ? "mixedMaxVolume" : "maxVolume";

          let selectedContainer;

          if (activeStep === 0) {
            selectedContainer = containerTypeList[0];
          } else {
            const allowedCodes = ["40' HC", "40' DV", "20' DV"];

            selectedContainer = containerTypeList
              .filter(
                (ct) =>
                  allowedCodes.includes(ct?.uniqueCode) &&
                  ct?.[volumeKey] >= currentVolume,
              )
              .sort((a, b) => a?.[volumeKey] - b?.[volumeKey])[0];
          }

          if (selectedContainer) {
            updatedData[`containerType${currentStep}`] = {
              value: selectedContainer.containerId,
              label: selectedContainer.uniqueCode,
              volume: selectedContainer?.[volumeKey],
            };
          }
        }

        if (
          !updatedData[`destination${currentStep}`] &&
          updatedData[`destination${previousStep}`]
        ) {
          updatedData[`destination${currentStep}`] = {
            ...updatedData[`destination${previousStep}`],
          };
        }

        if (
          !updatedData[`loadingWeek${currentStep}`] &&
          updatedData[`loadingWeek${previousStep}`]
        ) {
          updatedData[`loadingWeek${currentStep}`] = {
            ...updatedData[`loadingWeek${previousStep}`],
          };
        }

        return updatedData;
      });
    }
  }, [activeStep, open, containerTypeList]);

  useEffect(() => {
    const currentStepItems = stepsData[activeStep] || [];

    const hasEK = currentStepItems.some((item) => item.vendorShortKey === "EK");
    const hasNonEK = currentStepItems.some(
      (item) => item.vendorShortKey !== "EK",
    );
    const isMixed = hasEK && hasNonEK;
    const volumeKey = isMixed ? "mixedMaxVolume" : "maxVolume";

    setMaxValueContainer(
      formData[`containerType${activeStep + 1}`]?.[volumeKey],
    );
  }, [formData, open, containerTypeList, activeStep, stepsData]);

  const getLoadingWeekList = async () => {
    const lacquered = newOrder.some((order) =>
      Object.values(order).some((value) => lacqueredRanges?.includes(value)),
    );
    const vendorIds = newOrder.map((obj) => obj.vendorNum);
    const filteredData = filteredLoadingWeek.filter((item) =>
      vendorIds.includes(item.vendorId),
    );

    let filterWeek = [];

    if (lacquered) {
      filterWeek = filteredData.filter((item) => {
        const lastWord = item.kitchenName.split(" ").slice(-2).join(" ");
        return (
          lastWord === "Kitchen Lacquered" ||
          lastWord === "Eco Lacquered" ||
          lastWord === "Spa Lacquered" ||
          lastWord === "Neo Lacquered" ||
          lastWord === "Kitchen (SystemLine)"
        );
      });
    } else {
      filterWeek = filteredData.filter((item) => {
        const lastWord = item.kitchenName.split(" ").slice(-2).join(" ");
        return lastWord === "Non Lacquered" || lastWord === "(Normal Handle)";
      });
    }

    if (filterWeek.length === 0) {
      console.warn("No matching weeks found for current selection");
      return;
    }
    const highestWeekObject = filterWeek.reduce((prev, current) => {
      if (current.year > prev.year) return current;
      if (current.year === prev.year && current.week > prev.week)
        return current;
      return prev;
    });

    const defaultWeek = isValidLoadingWeeks
      ? uniqueLoadingWeek
      : highestWeekObject.week;
    const currentYears = isValidLoadingWeeks
      ? uniqueLoadingYear
      : highestWeekObject.year;
    let adjustedWeek = defaultWeek;
    let adjustedYear = currentYears;

    if (hasSuperRole) {
      adjustedWeek = defaultWeek - 1;

      if (adjustedWeek < 1) {
        adjustedYear = currentYears - 1;
        adjustedWeek = moment(`${adjustedYear}-01-01`).isoWeeksInYear();
      }
    }
    const generateDateStrings = (startYear, defaultWeek) => {
      const result = [];
      const disabledWeeks = [31, 32, 33];
      for (let year = startYear; year <= startYear + 4; year++) {
        const maxWeek = moment(`${year}-01-01`).isoWeeksInYear();
        const startWeek = year === startYear ? defaultWeek : 1;

        for (let week = startWeek; week <= maxWeek; week++) {
          result.push({
            value: week,
            label: `${week}/${year}`,
            year,
            isDisabled: disabledWeeks.includes(week),
          });
        }
      }

      return result;
    };
    const weekOption = generateDateStrings(adjustedYear, adjustedWeek);

    setCurrentWeek(adjustedWeek);
    setCurrentYears(adjustedYear);

    setWeekOption(weekOption);
  };

  useEffect(() => {
    if (open) {
      getLoadingWeekList();
    }
  }, [open]);

  const getStartDateOfWeek = async (year, week) => {
    const list = await OAuthService.getList(
      `${getDateUrl}?week=${week}&year=${year}`,
    );
    const data = moment(list.data).subtract(3, "weeks").format("DD-MM-YYYY");

    setCutOffDate(data);
  };
  useEffect(() => {
    if (currentWeek && currentYears) {
      getStartDateOfWeek(currentYears, currentWeek);
    }
  }, [currentWeek, currentYears]);

  const vendorShortKeys = [
    ...new Set(
      stepsData[activeStep]?.map((order) => order.vendorShortKey) || [],
    ),
  ];

  const handleOnClose = () => {
    onClose();
    setFormData({});
    setStepsData([]);
    setActiveStep(0);
    setInitialStepsCalculated(false);
  };
  const productKey = vendorShortKeys.join(" | ");
  return (
    <>
      <Dialog
        open={open}
        onClose={handleOnClose}
        fullWidth
        maxWidth="lg"
        className={clsx(classes.root)}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
      >
        <AppBar
        position="static"
          color="secondary"
          sx={{ cursor: "move" }}
          id="draggable-dialog-title"
        >
          <Toolbar className="flex w-full justify-between">
            <Typography variant="subtitle1" color="inherit">
              Container
            </Typography>
            <IconButton onClick={handleOnClose}>
              <Icon>close</Icon>
            </IconButton>
          </Toolbar>
        </AppBar>
        <DialogContent classes={{ root: "p-16 sm:p-24" }}>
          <Stepper
            activeStep={activeStep}
            className="pb-16"
            sx={{
              "& .MuiStepIcon-root.Mui-active": {
                color: theme.palette.secondary.main,
              },
              "& .MuiStepIcon-root.Mui-completed": {
                color: theme.palette.secondary.main,
              },
            }}
          >
            {stepsData.map((_, index) => (
              <Step key={index}>
                <StepLabel>{`Container ${index + 1}`}</StepLabel>
              </Step>
            ))}
          </Stepper>
          <div>
            <div className="flex justify-between my-10">
              <Paper className="flex flex-col items-center justify-center p-10 border-2 rounded w-full mr-10">
                Loading week
                <div>
                  <strong>
                    {currentWeek}/{currentYears}
                  </strong>
                </div>
              </Paper>
              <Paper className="flex flex-col items-center justify-center p-10 border-2 rounded w-full mx-10">
                Total Orders
                <div>
                  <strong>{stepsData[activeStep]?.length}</strong>
                </div>
              </Paper>
              <Paper className="flex flex-col items-center justify-center p-10 border-2 rounded w-full mx-10">
                Cut off date
                <div>
                  <strong>{cutOffDate}</strong>
                </div>
              </Paper>
              <Paper className="flex flex-col items-center justify-center p-10 border-2 rounded w-full mx-10">
                Total Volume
                <div>
                  <strong>
                    {stepsData[activeStep]
                      ?.reduce((a, b) => a + Number(b.volume), 0)
                      .toFixed(3)}
                  </strong>
                </div>
              </Paper>
              <Paper className="flex flex-col items-center justify-center p-10 border-2 rounded w-full ml-10">
                Products
                <div>
                  <strong>{productKey}</strong>
                </div>
              </Paper>
            </div>
            <Box>
              <ul className="order-detail-summary">
                <li>
                  <label>Container Type</label>
                  <div className="flex-grow pr-24">
                    <Select
                      options={containerTypeOptions}
                      className="w-full"
                      styles={customStyles()}
                      onChange={(selectedOption) =>
                        handleSelectChange(
                          selectedOption,
                          `containerType${activeStep + 1}`,
                        )
                      }
                      name={`containerType${activeStep + 1}`}
                      value={formData[`containerType${activeStep + 1}`]}
                    />
                  </div>
                </li>
                <li>
                  <label>
                    Expected Loading Week{" "}
                    <Typography
                      component="span"
                      color="error"
                    >
                      *
                    </Typography>
                  </label>
                  <div className="flex-grow pr-24">
                    <Select
                      options={weekOption}
                      className="w-full"
                      styles={customStyles()}
                      onChange={(selectedOption) =>
                        handleSelectChange(
                          selectedOption,
                          `loadingWeek${activeStep + 1}`,
                        )
                      }
                      name={`loadingWeek${activeStep + 1}`}
                      value={formData[`loadingWeek${activeStep + 1}`]}
                    />
                    {error && <p>This field is required</p>}
                  </div>
                </li>
                <li>
                  <label>Container Status</label>
                  <div className="flex-grow pr-24">
                    <Select
                      options={containerStatusOptions}
                      className="w-full"
                      styles={customStyles()}
                      onChange={(selectedOption) =>
                        handleSelectChange(
                          selectedOption,
                          `containerStatus${activeStep + 1}`,
                        )
                      }
                      // defaultValue={"open"}
                      name={`containerStatus${activeStep + 1}`}
                      value={formData[`containerStatus${activeStep + 1}`]}
                      isDisabled
                    />
                  </div>
                </li>
                <li>
                  <label>
                    Destination / Region <span style={{ color: "red" }}>*</span>
                  </label>
                  <div className="flex-grow pr-24">
                    <Select
                      // options={hasPartner?regionOptions:portOptions}
                      options={regionOptions}
                      styles={customStyles()}
                      className="w-full"
                      onChange={(selectedOption) =>
                        handleSelectChange(
                          selectedOption,
                          `destination${activeStep + 1}`,
                        )
                      }
                      name={`destination${activeStep + 1}`}
                      value={formData[`destination${activeStep + 1}`]}
                    />
                  </div>
                </li>

                <li>
                  <label>Forwarder </label>
                  <div className="flex-grow pr-24">
                    <Grid container spacing={2}>
                      <Grid item xs={6}>
                        <TextField
                          fullWidth
                          label="Name"
                          name={`name${activeStep + 1}`}
                          value={formData[`name${activeStep + 1}`] || ""}
                          onChange={handleFormChange}
                          variant="outlined"
                          type="text"
                          autoComplete="new-password"
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <TextField
                          fullWidth
                          label="Contact Number"
                          name={`contact${activeStep + 1}`}
                          value={formData[`contact${activeStep + 1}`] || ""}
                          onChange={handleFormChange}
                          variant="outlined"
                          type="number"
                          autoComplete="new-password"
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          label="Email"
                          name={`emailAddress${activeStep + 1}`}
                          value={
                            formData[`emailAddress${activeStep + 1}`] || ""
                          }
                          onChange={handleFormChange}
                          variant="outlined"
                          type="email"
                          autoComplete="new-password"
                        />
                      </Grid>
                    </Grid>
                  </div>
                </li>
                <li>
                  <label>Comment</label>
                  <div className="flex-grow pr-24">
                    <TextField
                      fullWidth
                      variant="outlined"
                      type="text"
                      name={`comment${activeStep + 1}`}
                      value={formData[`comment${activeStep + 1}`] || ""}
                      onChange={handleFormChange}
                    />
                  </div>
                </li>
              </ul>
            </Box>
            <div className="mt-16" style={{ height: 400 }}>
              <AgGridTable
                rowData={stepsData[activeStep]}
                context={{ lacqueredRanges }}
                columnDefs={containerColumnDefs}
                onRowDoubleClicked={onRowDoubleClicked}
                onSelectionChanged={onSelectionChanged}
                onGridReady={onGridReady}
                ref={gridRef}
                rowGroupPanelShow="never"
              />
            </div>
            <Box
              className="text-right"
              sx={{
                fontSize: 13,
                padding: "5px 10px",
                background: theme.palette.background.paper,
                border: `1px solid ${theme.palette.divider}`,
                borderTop: "none",
              }}
            >
              Total Volume:{" "}
              <strong>
                {stepsData[activeStep]
                  ?.reduce((a, b) => a + Number(b.volume), 0)
                  .toFixed(3)}
              </strong>
            </Box>
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            color="inherit"
            disabled={activeStep === 0}
            onClick={handleBack}
            sx={{ mr: 1 }}
          >
            Back
          </Button>
          <Box sx={{ flex: "1 1 auto" }} />
          <Button
            onClick={handleNext}
            color="secondary"
            variant="contained"
            disabled={
              formData[`destination${activeStep + 1}`] &&
                formData[`loadingWeek${activeStep + 1}`]
                ? false
                : true
            }
          >
            {activeStep === stepsData.length - 1 ? "Finish" : "Next"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
